export const Types = {
  START_SNACK_BAR: 'START_SNACK_BAR',
  END_SNACK_BAR: 'END_SNACK_BAR',

  START_TOGGLE_SIDEBAR: 'START_TOGGLE_SIDEBAR',
  END_TOGGLE_SIDEBAR: 'END_TOGGLE_SIDEBAR',
};
